import React from "react"
import { QueryClientProvider } from "@tanstack/react-query"
import { createRoot } from "react-dom/client"
import { includes } from "lodash"
import { Features } from "core/features"
import { queryClient } from "core/query-client"
import { UserProvider } from "hooks/use-current-user"
import { PromoCodeProvider } from "hooks/use-promo-code"

let components = {}

const mount = component => {
  components = {
    ...components,
    ...component
  }
}

export default mount
;(function() {
  let events = ["DOMContentLoaded", "angular:loaded"]
  let renderedComponentRoots = []

  const load = function() {
    Array.prototype.slice
      .call(document.querySelectorAll("[data-component]"))
      .forEach(function(element) {
        var component = components[element.dataset.component]
        var props = {}
        var data = element.dataset

        if (data.props) {
          props = JSON.parse(data.props)
        } else {
          // TODO: Setting props via named data attributes is deprecated.
          // Remove after fixing where this is used.
          Object.setPrototypeOf(data, {}) // for(key in object){} doesn't work in Safari. This fixes it.
          for (let key in data) {
            if (key === "component") {
              continue
            }
            try {
              props[key] = JSON.parse(data[key])
            } catch (e) {
              props[key] = data[key]
            }
          }
        }

        if (!component) {
          return
        }

        const Element = () => (
          <QueryClientProvider client={queryClient}>
            <UserProvider>
              <Features>
                <PromoCodeProvider>
                  {React.createElement(component, props)}
                </PromoCodeProvider>
              </Features>
            </UserProvider>
          </QueryClientProvider>
        )

        if (!includes(renderedComponentRoots, element)) {
          const root = createRoot(element)
          root.render(<Element />)
          renderedComponentRoots.push(element)
        }
      })
  }

  for (let event of events) {
    document.addEventListener(event, load)
  }

  if (document.readyState === "complete") {
    load()
  }
})(window)
